import React, { useEffect, useState } from 'react';
import { LoadingModal } from 'components/response/LoadingModal';
import { LOAN_ACTIONS } from 'constants/LoanActions';
import { FormContext } from 'context/FormContext';
import { ActionButtonConfig } from 'models/ActionButtonConfig';
import { useLoanFormContainerControl } from 'hooks/useLoanFormContainerControl';
import { LoanSimpleVehicleInfoForm } from 'components/single-form-view/loan/LoanSimpleVehicleInfoForm';
import { useLogin } from 'hooks/useLogin';
import { useControlModal } from 'hooks/useControlModal';
import { InfoModal } from 'components/modals/InfoModal';
import { useHistory } from 'react-router-dom';
import { RESPONSE_PATH, RESPONSE_VIEW_ERROR } from 'constants/ResponseType';
import { DATA_LAYER_RESPONSE_KEY } from 'constants/DataLayers';
import { LoanSelfServicesModal } from 'components/modals/loan/LoanSelfServicesModal';
import { MultiFormContainer } from 'components/multi-form/MultiFormContainer';
import { LoanPersonalInfoForm } from 'components/single-form-view/loan/LoanPersonalInfoForm';

const config = [
	{
		buttonBackName: 'Volver',
		buttonNextName: 'Comenzar',
		backAction: LOAN_ACTIONS.BACK_TO_HOME,
		nextAction: LOAN_ACTIONS.SAVE_FORM_AND_UPDATE_WITH_KNOCKOUT,
	},
	{
		buttonBackName: 'Volver',
		buttonNextName: 'Continuar',
		backAction: LOAN_ACTIONS.RESET_ID_STATUS_AND_BACK_STEP,
		nextAction: LOAN_ACTIONS.UPDATE_FORM_WITH_SCORING_SYNC_AND_FINISH,
	},
];

export const LoanSelfCareMultiFormContainer = () => {
	const history = useHistory();
	const [login] = useLogin();
	const [formData, setformData] = useState({});
	const {
		executeAction,
		step,
		enableButton,
		setEnableButton,
		showLoadingModal,
		setShowLoadingModal,
		showLongModal,
	} = useLoanFormContainerControl(
		DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_INFO_PERSONAL_RECHAZO,
		DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_SCORING_RECHAZO
	);

	const { open, toggle } = useControlModal(true);

	const configAction: ActionButtonConfig[] = config.map((values) => {
		return {
			buttonBackName: values.buttonBackName,
			buttonNextName: values.buttonNextName,
			buttonBackClick: () => {
				executeAction(values.backAction, { ...formData, flow: 'AUTOATENCION', trafficSources: sessionStorage.getItem('trafficSources') });
			},
			buttonNextClick: () => {
				executeAction(values.nextAction, { ...formData, flow: 'AUTOATENCION', trafficSources: sessionStorage.getItem('trafficSources') });
			},
		} as ActionButtonConfig;
	});

	useEffect(
		() => {
			setShowLoadingModal(true);
			login(
				() => setShowLoadingModal(false),
				() => history.push(`${RESPONSE_PATH}/${RESPONSE_VIEW_ERROR}/error`)
			);
		},
		//eslint-disable-next-line
		[]
	);

	const views: JSX.Element[] = [
		<LoanPersonalInfoForm dataLayerKey={DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_INFO_PERSONAL} />,
		<LoanSimpleVehicleInfoForm
			dataLayerKey={DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_INFO_VEHICULO}
		/>,
	];

	return (
		<>
			{open ? (
				<InfoModal
					dataLayerKey={DATA_LAYER_RESPONSE_KEY.LOAN_AUTOATENCION_BIENVENIDA}
					open={open}
					title="Bienvenido al flujo de autoatención"
					content={<LoanSelfServicesModal />}
					buttonLabel="Entendido"
					toggleModal={toggle}
				/>
			) : null}
			<FormContext.Provider
				value={{
					setError: setEnableButton,
					setData: setformData,
					//storage: storageService,
				}}
			>
				<LoadingModal showLoadingModal={showLoadingModal} isLongTime={showLongModal} />

				<MultiFormContainer
					controlConfig={configAction}
					views={views}
					currentStep={step}
					isError={enableButton}
				/>
			</FormContext.Provider>
		</>
	);
};
